import { z } from 'zod'
import { dateOrIsoString } from '~/prix/types/date'
import sql from '~/prix/utils/sql'
import { residenceObject } from '../residence/residenceObject'

// Placa de identificação vinculada a uma residência. Uma residência pode ter várias placas
export const residenceIdentificationPlateObject = z.object({
  id: z.string().uuid(),
  code: z.number().int().positive(),
  residenceId: residenceObject.shape.id,
  clientId: z.number().int().nullish(),
  manufacturedAt: dateOrIsoString().nullish(),
  deliveredAt: dateOrIsoString().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  synchronizedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export type ResidenceIdentificationPlateType = z.infer<typeof residenceIdentificationPlateObject>

// Item da listagem: a placa combinada com os dados da residência vinculada.
export const residenceIdentificationPlateListItemObject = z.object({
  id: residenceIdentificationPlateObject.shape.id,
  code: residenceIdentificationPlateObject.shape.code,
  residenceId: residenceObject.shape.id,
  residenceCode: z.number().int().nullish(),
  residenceCustomCode: z.string().nullish(),
  residenceTitle: z.string().nullish(),
  residenceFullAddress: z.string().nullish(),
  residencePlusCode: z.string().nullish(),
  residenceIsRural: z.boolean().nullish(),
  residenceLatitude: z.number().nullish(),
  residenceLongitude: z.number().nullish(),
  residenceCommunityId: z.string().uuid().nullish(),
  // Coluna combinada de busca textual da residência (espelha o front-end).
  residenceSourceFilter: z.string().nullish(),
  manufacturedAt: dateOrIsoString().nullish(),
  deliveredAt: dateOrIsoString().nullish(),
  isManufactured: z.boolean(),
  isDelivered: z.boolean(),
  clientId: z.number().int().nullish(),
  insertUserId: z.string().nullish(),
  editUserId: z.string().nullish(),
  createdAt: dateOrIsoString().nullish(),
  updatedAt: dateOrIsoString().nullish(),
  synchronizedAt: dateOrIsoString().nullish(),
  deletedAt: dateOrIsoString().nullish(),
})

export type ResidenceIdentificationPlateListItemType = z.infer<
  typeof residenceIdentificationPlateListItemObject
>

// Mapeamento dos campos do item de listagem para as colunas SQL correspondentes,
// usado por expressionToPostgres (filtros) e pela ordenação.
export const listPropertyMap = {
  id: sql`residence_identification_plate.id`,
  code: sql`residence_identification_plate.code`,
  residenceId: sql`residence.id`,
  residenceCode: sql`residence.code`,
  residenceCustomCode: sql`split_part(trim(residence.source_filter), ' ', 1)`,
  residenceTitle: sql`residence.title`,
  residenceFullAddress: sql`residence.full_address`,
  residencePlusCode: sql`residence.plus_code`,
  residenceIsRural: sql`residence.is_rural`,
  residenceLatitude: sql`residence.latitude`,
  residenceLongitude: sql`residence.longitude`,
  residenceCommunityId: sql`residence.community_id`,
  residenceSourceFilter: sql`residence.source_filter`,
  manufacturedAt: sql`residence_identification_plate.manufactured_at`,
  deliveredAt: sql`residence_identification_plate.delivered_at`,
  isManufactured: sql`(residence_identification_plate.manufactured_at IS NOT NULL)`,
  isDelivered: sql`(residence_identification_plate.delivered_at IS NOT NULL)`,
  clientId: sql`residence_identification_plate.client_id`,
  insertUserId: sql`residence_identification_plate.insert_user_id`,
  editUserId: sql`residence_identification_plate.edit_user_id`,
  createdAt: sql`residence_identification_plate.created_at`,
  updatedAt: sql`residence_identification_plate.updated_at`,
  synchronizedAt: sql`residence_identification_plate.synchronized_at`,
  deletedAt: sql`residence_identification_plate.deleted_at`,
}
